
import { debounce } from '../../Tools.js';

var ProductSearchForm = function () {

    var form;
    var inputElement;
    // var searchSubmitElement;
    var clearSubmitElement;
    var resultElement;
    var currentAjaxRequest;

    // ajax metodu
    var ajaxHandle = function () {

        if (currentAjaxRequest) {
            currentAjaxRequest.abort();
        }
        resultElement.classList.remove("d-none");

        var keyword = inputElement.value.toLocaleLowerCase('tr-TR')

        let data = {
            search: keyword
        }

        if (!keyword) {
            complate();
            return;
        }

        form.querySelector('.fa-xmark').classList.add('d-none')
        form.querySelector('.spinner-border').classList.remove('d-none')

        currentAjaxRequest = $.ajax({
            url: apiUrl + '/GetProducts',
            type: "POST",
            dataType: "json",
            data: data,
            error: function error(xhr) {
                complate();
            },
            beforeSend: function () {
                resultElement.innerHTML = '';

                let keywordTemplate = '<a href="/search/' + keyword + '" class="product">'
                keywordTemplate += '<div class="title"><span class="fw-bold">' + keyword + '</span></div></a>';
                resultElement.insertAdjacentHTML('beforeend', keywordTemplate)

            },
            complete: function () {
                complate();
            },
            success: function success(xhr) {

                var products = xhr;
                products.forEach(function (data) {
                    let name = JSON.parse(data.title)[langCodeLong];
                    if (name == null || name == undefined) {
                        name = JSON.parse(data.title)[langCodeLongDefault];
                    }

                    let picture = JSON.parse(data.thumbnail)[langCodeLong];
                    if (picture == null || picture == undefined) {
                        picture = JSON.parse(data.thumbnail)[langCodeLongDefault];
                    }

                    let slug = JSON.parse(data.slug)[langCodeLong];
                    if (slug == null || slug == undefined) {
                        slug = JSON.parse(data.title)[langCodeLongDefault];
                    }

                    // fiyat
                    let price = data.sales_price
                    if (data.discount) {
                        price = data.discount.discount_price
                    }
                    price = currencyFormat.from(price)

                    let template = '<a href="' + baseUrl + '/product/' + slug + '"class="product">'

                    if (picture) {
                        template += '<div class="image"><img class="lazyload" src="' + picture + '"></div>'
                    }


                    template += '<div class="title"><span>' + name + '</span><span class="price">' + currencyFormat.to(price) + '</span></div></a>';


                    if (name) {
                        resultElement.insertAdjacentHTML('beforeend', template)
                    }
                })

            }
        });

    }

    // arama tamamlandığında
    var complate = function () {
        // searchSubmitElement.removeAttribute('disabled')
        form.querySelector('.spinner-border').classList.add('d-none')
        form.querySelector('.fa-xmark').classList.remove('d-none')
    }

    // form yüklendiğinde
    var formHandle = function () {

        // ürün arama
        $(inputElement).on('keyup', form, function (e) {
            var keyword = this.value.toLocaleLowerCase('tr-TR')

            form.querySelector('#search-href').setAttribute('href', '/search/' + keyword)
            if (keyword.length >= 3) {
                if (e.keyCode === 13) {
                    window.location.href = '/search/' + keyword
                    return;
                }

                // debounce işlemi
                debounce(ajaxHandle, 500)();

                // ajaxHandle();
            } else {
                form.querySelector('.spinner-border').classList.add('d-none')
                form.querySelector('.fa-xmark').classList.add('d-none')
                // resultElement.classList.add("d-none");
                // resultElement.innerHTML = '';
            }
        })

        $(inputElement).on('change', form, function (e) {
            if (e.target.value.includes("@")) {
                e.target.value = ''
            }
        })

        // temizleme butonu
        $(clearSubmitElement.closest('button')).on('click', form, function (e) {
            e.preventDefault();
            // searchSubmitElement.setAttribute('disabled', '')
            form.querySelector('.fa-xmark').classList.add('d-none')
            inputElement.setAttribute('value', null)
            inputElement.value = '';
            resultElement.classList.add("d-none");
            resultElement.innerHTML = '';
        })


        // çıkan sonuçlar dışa tıklama olayları
        $(document).on('click', function (event) {
            if (!$(event.target).is(form)) {
                resultElement.classList.add("d-none");
            }

            if ($(event.target).is(inputElement) && inputElement.value.length > 1) {
                resultElement.classList.remove("d-none");
            }
        });

    }

    return {
        init: function () {
            form = document.querySelector('[data-search-form]');
            inputElement = form.querySelector('[data-search-input]');
            // searchSubmitElement = form.querySelector('[data-search-submit]')
            clearSubmitElement = form.querySelector('[data-search-clear]')
            resultElement = form.querySelector('[data-search-result]')
            if (!form) {
                return;
            }
            formHandle();

            inputElement.value = "";
        },
    };

}();

$(function () {
    ProductSearchForm.init();


});

window.onload = function () {
    setTimeout(function () {
        document.querySelector('[data-search-input]').value = ''
    }, 1000);
};